import apiClient from './client';

export interface Company {
  id: string;
  name: string;
  taxNumber?: string;
  phone?: string;
  email?: string;
  address?: string;
  city?: string;
  notes?: string;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateCompanyDto {
  name: string;
  taxNumber?: string;
  phone?: string;
  email?: string;
  address?: string;
  city?: string;
  notes?: string;
}

export interface UpdateCompanyDto extends Partial<CreateCompanyDto> {
  isActive?: boolean;
}

export const companiesApi = {
  getAll: async (): Promise<Company[]> => {
    const response = await apiClient.get('/companies');
    return response.data.map((item: any) => ({
      ...item,
      id: item._id,
    }));
  },

  getById: async (id: string): Promise<Company> => {
    const response = await apiClient.get(`/companies/${id}`);
    return {
      ...response.data,
      id: response.data._id,
    };
  },

  create: async (data: CreateCompanyDto): Promise<Company> => {
    const response = await apiClient.post('/companies', data);
    return {
      ...response.data,
      id: response.data._id,
    };
  },

  update: async (id: string, data: UpdateCompanyDto): Promise<Company> => {
    const response = await apiClient.patch(`/companies/${id}`, data);
    return {
      ...response.data,
      id: response.data._id,
    };
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/companies/${id}`);
  },
};
